/* eslint-disable no-case-declarations */
import {
  ADD_HEADLINE,
  REMOVE_HEADLINE,
  CHANGE_HEADLINE
} from "../actions/types";

const initialState = [""];
export default function(state = initialState, action) {
  let headlines;
  let index;
  let value;

  switch (action.type) {
    case ADD_HEADLINE:
      headlines = [...state];
      headlines.push("");
      return headlines;

    case REMOVE_HEADLINE:
      headlines = [...state];
      index = action.payload;
      headlines.splice(index, 1);
      return headlines;

    case CHANGE_HEADLINE:
      index = action.payload.index;
      value = action.payload.value;
      headlines = [...state];
      headlines[index] = value;
      return headlines;
    default:
      return state;
  }
}
